export const CODE_QR_SMART_COLIS = 'https://smartcolis.com/code-qr';
export const generateCodeQrUrl = (tracker: string) => `${CODE_QR_SMART_COLIS}/${tracker}`;
